export default "__VITE_ASSET__CYH9sIBi__"